import { FINANCIAL_INFO_VIEWS_PATHS } from 'app/pages/loanApplication/tabs/financialInfo/FinancialInfo.constants';

import { ENTITY_REFERENCE_TYPE } from '../../../TeamChat.entityReferences.utils';

// Reverse of loanNavigation's ENTITY_TYPE_TO_FINANCIAL_VIEW — resolves which entity type the
// currently-open financial-info subtab represents, so its group can be surfaced first.
export const FINANCIAL_SUBTAB_TO_ENTITY_TYPE = {
  [FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT]: ENTITY_REFERENCE_TYPE.INCOME,
  [FINANCIAL_INFO_VIEWS_PATHS.ASSETS]: ENTITY_REFERENCE_TYPE.ASSET,
  [FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES]: ENTITY_REFERENCE_TYPE.LIABILITY,
  [FINANCIAL_INFO_VIEWS_PATHS.REO]: ENTITY_REFERENCE_TYPE.REO,
};
